import { RetailerPartnerType } from '../enum/index.js';
const config = {
    type: RetailerPartnerType.KROGER,
    defaultUrl: 'https://www.kroger.com/'
};
export default config;
